// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__3Xbcs","row":"Node_row__3DYWI","label":"Node_label__3GA3w","footer":"Node_footer__2m-Tl"};